class CommentService {
    OPEN_EXPLORE_POINT = 'open_explore_point';
    OPEN_EXPLORE_TRAIL = 'open_explore_trail';

    displayName(comment) {
        switch (comment.entity_name) {
            case this.OPEN_EXPLORE_POINT:
                return "Point";
            case this.OPEN_EXPLORE_TRAIL:
                return "Trail";
            default:
                return "Unknown";
        }
    }
    getTextForComment(t, comment, key) {
        return comment.user
            ? t(key, {
                firstname: comment.user.firstname,
                lastname: comment.user.lastname,
                username: comment.user.username,
            })
            : t(key + '_user_name', {
                username: (comment.user_name !== null && comment.user_name !== '')
                    ? comment.user_name
                    : t('module.comment.anonymous')
            })
    }
}

export default new CommentService();



// WEBPACK FOOTER //
// src/services/comment.js